/**
 * @fileoverview Public layout for landing pages (no sidebar/navbar)
 */
export const PublicLayout = ({ children }) => {
    return (<div className="public-layout">
      {children}
    </div>);
};
